import TemplateView from '../../../../js/TemplateView'
import {connect} from '../../../../js/redux/utils'
import LoadingPopup from '../../../../js/LoadingPopup'
import {bindActionCreators} from 'redux'
import FeedsContent from './FeedsContent'
import HeaderPanel from './HeaderPanel'
import {canManageAccountsAndPermissions} from '../../../../js/loggedInUser/selectors'
import {isFeedsContentLoading, isLoading} from '../selectors'
import LoadingMoire from '../../../../js/LoadingMoire'
import {startPageLoading} from '../actions'
import EditFeedLightBox from './lightbox/edit/EditFeedLightBox'
import {openCreateFeedLightBox, openExportICalLightBox} from './lightbox/actions'
import ExportICalLightBox from './lightbox/export/ExportICalLightBox'
import {isLightBoxLoading} from './lightbox/selectors'
import LoadingContainer from '../../../../js/util/LoadingContainer'

class ICalendarFeedsPage extends TemplateView {

    constructor({
        startPageLoading,
        openCreateFeedLightBox,
        openExportICalLightBox,
    }) {
        super()

        this.state = {
            tabsShown: true,
            loading: false,
            lightBoxLoading: false,
            feedsContentLoading: false,
        }

        this.actions = {
            startPageLoading,
            openCreateFeedLightBox,
            openExportICalLightBox,
        }

        this.onStatePropertyChanged('tabsShown', tabsShown => this.headerPanel.toggle(tabsShown))

        this.onStatePropertyChanged('loading', loading => {
            this.loadingMoire.toggle(loading)
            this.feedsContentContainer.toggle(!loading)
        })

        this.onStatePropertyChanged('lightBoxLoading', lightBoxLoading => this.loadingPopup.toggle(lightBoxLoading))

        this.onStatePropertyChanged('feedsContentLoading', feedsContentLoading => this.feedsContentContainer.setState({loading: feedsContentLoading}))
    }

    templateHtml() {
        return `<div class='iCalPage'>
                    <div id="incorrectDateTooltip" class="yellowTooltip tooltipText">
                        <div id="incorrectDateTooltip_textPlaceholder"/>
                    </div>
                    <div class='pageHeader'>
                        <%=pageHeader%>
                    </div>
                    <div class='iCalContent'>
                        <div class='headerPanelWrapper'/>
                        <div class='feedsContentArea'/>
                    </div>
                    <div class='createLightboxPlaceholder'/>
                    <div class='editLightboxPlaceholder'/>
                </div>`
    }

    messageKeys() {
        return {
            pageHeader: 'icalendar.page.title',
        }
    }

    afterRender() {
        this.find('.yellowTooltip').hide()
        this.headerPanel = new HeaderPanel({
            onCreateButtonClick: this.actions.openCreateFeedLightBox,
            onExportButtonClick: this.actions.openExportICalLightBox,
        }).init(this.find('.headerPanelWrapper'))

        this.feedsContentContainer = new LoadingContainer({
            contentComponent: new FeedsContent({
                onCreateButtonClick: this.actions.openCreateFeedLightBox,
                onExportButtonClick: this.actions.openExportICalLightBox,
            }),
            loadingMoireConfig: {
                additionalSpinnerSettings: {
                    radius: 17,
                    length: 13,
                    width: 4
                },
            },
        }).init(this.find('.feedsContentArea'))

        this.loadingMoire = new LoadingMoire({
            additionalSpinnerSettings: {
                radius: 17,
                length: 13,
                width: 4,
                position: 'fixed',
            },
        }).init(this.getEl())

        this.actions.startPageLoading()

        new EditFeedLightBox().init(this.getEl())
        new ExportICalLightBox().init(this.getEl())

        this.loadingPopup = new LoadingPopup().init("contentLoadingPopup")
    }
}

export default connect(
    state => ({
        tabsShown: canManageAccountsAndPermissions(state),
        loading: isLoading(state),
        lightBoxLoading: isLightBoxLoading(state),
        feedsContentLoading: isFeedsContentLoading(state),
    }),
    dispatch => bindActionCreators({
        startPageLoading,
        openCreateFeedLightBox,
        openExportICalLightBox,
    }, dispatch)
)(ICalendarFeedsPage)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/ICalendarFeedsPage.js